import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { reduxKey } from './constants';
import { updateSubmittingState, updateSubmitErrorString } from './actionCreators';
import { handleActions } from 'redux-actions';
const actionHandlers = handleActions({
    [`${updateSubmittingState}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            submittingState: action.payload.submittingState
        }),
    [`${updateSubmitErrorString}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            submitErrorString: action.payload.submitErrorString
        })
}, {
    submittingState: 'idle',
    submitErrorString: ''
});
const reducers = {
    [reduxKey]: actionHandlers
};
export default reducers;

//# sourceMappingURL=reducers.js.map